var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "f16 subject" }, [
      _vm._v("\n    推荐货品\n    "),
      _c(
        "a",
        {
          staticClass: "f14 blue pull-right",
          attrs: { target: "_blank", href: _vm.origin.VUE_APP_ZNT2 + "store" }
        },
        [_vm._v("更多 >")]
      )
    ]),
    _c(
      "ul",
      { staticClass: "ul-cls optimize-list" },
      _vm._l(_vm.goodList.slice(0, 5), function(item) {
        return _c(
          "li",
          {
            key: item.goodsId,
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.openLink(item, _vm.event)
              }
            }
          },
          [
            item.promotionType
              ? _c(
                  "a",
                  { staticClass: "tags" },
                  [
                    item.promotionType === "折扣"
                      ? [_vm._v(_vm._s(item.promotionRate) + "折优惠")]
                      : _vm._e(),
                    item.promotionType === "直降"
                      ? [_vm._v("直降" + _vm._s(item.promotionRate) + "元")]
                      : _vm._e(),
                    item.promotionType === "买赠"
                      ? [
                          _vm._v(
                            "买" +
                              _vm._s(item.promotionStock) +
                              "赠" +
                              _vm._s(item.giftCount)
                          )
                        ]
                      : _vm._e(),
                    item.promotionType === "集采" ? [_vm._v("集采")] : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _c("a", { staticClass: "img" }, [
              item.goodsImg
                ? _c("img", {
                    attrs: {
                      title: item.goodsNameStr || item.goodsName,
                      src: item.goodsImg + "?imageView2/1/w/300/h/300"
                    }
                  })
                : _c("img", {
                    attrs: {
                      src: require("./images/goods.png"),
                      title: item.goodsNameStr || item.goodsName
                    }
                  })
            ]),
            _c(
              "a",
              {
                staticClass: "text ellipsis_two",
                attrs: { title: item.goodsNameStr || item.goodsName }
              },
              [_vm._v(_vm._s(item.goodsNameStr || item.goodsName))]
            ),
            _c("div", { staticClass: "price" }, [
              item.sellFactPrice
                ? _c("span", { staticClass: "price-cur" }, [
                    _vm._v(_vm._s(item.sellFactPrice))
                  ])
                : _c("span", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v("点击询价")
                  ]),
              item.sellFactPrice !== item.sellPrice
                ? _c("span", { staticClass: "price-discount" }, [
                    _vm._v("¥" + _vm._s(item.sellPrice))
                  ])
                : _vm._e(),
              _c("img", {
                staticClass: "el-icon-shopping-cart-full pointer",
                attrs: { src: require("./images/car.png") },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.addToCarts(item)
                  }
                }
              })
            ])
          ]
        )
      }),
      0
    ),
    _c(
      "ul",
      { staticClass: "ul-cls optimize-list mar-t20" },
      _vm._l(_vm.goodList.slice(5, 10), function(item) {
        return _c(
          "li",
          {
            key: item.goodsId,
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.openLink(item, _vm.event)
              }
            }
          },
          [
            item.promotionType
              ? _c(
                  "a",
                  { staticClass: "tags" },
                  [
                    item.promotionType === "折扣"
                      ? [_vm._v(_vm._s(item.promotionRate) + "折优惠")]
                      : _vm._e(),
                    item.promotionType === "直降"
                      ? [_vm._v("直降" + _vm._s(item.promotionRate) + "元")]
                      : _vm._e(),
                    item.promotionType === "买赠"
                      ? [
                          _vm._v(
                            "买" +
                              _vm._s(item.promotionStock) +
                              "赠" +
                              _vm._s(item.giftCount)
                          )
                        ]
                      : _vm._e(),
                    item.promotionType === "集采" ? [_vm._v("集采")] : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _c("a", { staticClass: "img" }, [
              item.goodsImg
                ? _c("img", {
                    attrs: {
                      title: item.goodsNameStr || item.goodsName,
                      src: item.goodsImg + "?imageView2/1/w/300/h/300"
                    }
                  })
                : _c("img", {
                    attrs: {
                      src: require("./images/goods.png"),
                      title: item.goodsNameStr || item.goodsName
                    }
                  })
            ]),
            _c(
              "a",
              {
                staticClass: "text ellipsis_two",
                attrs: { title: item.goodsNameStr || item.goodsName }
              },
              [_vm._v(_vm._s(item.goodsNameStr || item.goodsName))]
            ),
            _c("div", { staticClass: "price" }, [
              item.sellFactPrice
                ? _c("span", { staticClass: "price-cur" }, [
                    _vm._v(_vm._s(item.sellFactPrice))
                  ])
                : _c("span", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v("点击询价")
                  ]),
              item.sellFactPrice !== item.sellPrice
                ? _c("span", { staticClass: "price-discount" }, [
                    _vm._v("¥" + _vm._s(item.sellPrice))
                  ])
                : _vm._e(),
              _c("img", {
                staticClass: "el-icon-shopping-cart-full pointer",
                attrs: { src: require("./images/car.png") },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.addToCarts(item)
                  }
                }
              })
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }